<template>
  <div class="page-wrapper py-4">
    <div  id="master" ref="master" class="master" @scroll="handleScroll">
      <menutop :menu/>
      <page1 id="page1" bg="white" class="section" />
      <page2 id="page2" bg="black" class="section" />
      <!-- <page3 id="page3" bg="black" class="section" /> -->
      <page5 id="page3" bg="white" class="section" />
      <!--  -->
      <page7 id="page4" bg="white" class="section" />
      <page8 id="page5" bg="black" class="section" />
      <page9 id="page6" bg="black" class="section" />
      <page6 id="page7" bg="white" class="section" />
      <!-- <page10 id="page9" bg="white" class="section" /> -->
      <page11 id="page8" bg="white" class="section" />
      <page12 id="page9" bg="white" class="section" />
      <page13 id="page10" bg="black" class="section" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import menutop from '@/components/structure/menutop.vue'
import page1 from '@/components/pages/flow/page1.vue'
import page2 from '@/components/pages/flow/page2.vue'
// import page3 from '@/components/pages/flow/page3.vue'
import page5 from '@/components/pages/flow/page5.vue'
import page6 from '@/components/pages/flow/page6.vue'
import page7 from '@/components/pages/flow/page7.vue'
import page8 from '@/components/pages/flow/page8.vue'
import page9 from '@/components/pages/flow/page9.vue'
// import page10 from '@/components/pages/flow/page10.vue'
import page11 from '@/components/pages/flow/page11.vue'
import page12 from '@/components/pages/flow/page12.vue'
import page13 from '@/components/pages/flow/page13.vue'

export default {
  name: 'FlowView',
  props:{
      con: {
          default: {},
          type: Object
      }
  },
  components: {
    menutop,
    page1,
    page2,
    // page3,

    page5,
    page6,
    page7,
    page8,
     page9,
    // page10,
    page11,
    page12,
    page13
  },
  watch: {
    currentSection() {
      if(document.getElementById(`page${this.currentSection}`)) {
        console.log(document.getElementById(`page${this.currentSection}`).getAttribute('bg'), this.currentSection);
        this.menu = document.getElementById(`page${this.currentSection}`).getAttribute('bg');
      }
    }
  },
  mounted(){
    if(document.getElementById(`page${this.currentSection}`)) {
        console.log(document.getElementById(`page${this.currentSection}`).getAttribute('bg'), this.currentSection);
        this.menu = document.getElementById(`page${this.currentSection}`).getAttribute('bg');
      }
  },
  data() {
    return {
      menu: 'white',
      currentSection: 1,
    };
  },
  methods: {
    handleScroll() {
      const scrollPosition = this.$refs.master.scrollTop;
      const windowHeight = window.innerHeight;
      const menuHeight = 80; // Altura del menutop
      const adjustedScrollPosition = scrollPosition + menuHeight;
      const section = Math.floor(adjustedScrollPosition  / windowHeight) + 1;
      if (section < 1) {
        this.currentSection = 1;
      } else if (section > 11) {
        this.currentSection = 11;
      } else {
        this.currentSection = section;
      }
    },
 
  },
}
</script>

<style lang="css">
/* 1) El wrapper ocupa toda la pantalla */
.page-wrapper {
  background-color: #F0EFEB; /* background color */
  width: 100%;
  height: 96vh;
  display: flex;
  justify-content: center; /* centra .master horizontalmente */
  align-items: center;     /* centra .master verticalmente */
  box-sizing: border-box;
}

.master {
  margin-top: 16px !important;
  position: relative;
  background-color: #fff;
  border-radius: 16px;
  width: 97.95vw !important;
  height: 95.5vh !important;
  max-width: none;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);

  /* Firefox */
  scrollbar-width: none !important;
  /* IE 10+ */
  -ms-overflow-style: none !important;
}

/* Chrome, Safari, Opera */
.master::-webkit-scrollbar {
  display: none !important;
}


@media (max-width: 992px) {
  .master {
      padding-top: 0px !important;
  }
}
</style>